export default __webpack_public_path__ + "static/media/video4.9ac15a37.webp";